module.exports = __webpack_public_path__ + "img/aiNose-header.5115daa7.jpg";